import $ from 'jquery';
import cookie from 'jquery.cookie';

class Notify {
    constructor(form) {
        this.form = $(form);
        this.submitButton = this.form.find('[type="submit"]');
        this.input = this.form.find('input[type="email"]');
        this.row = this.form.find('.form__row');
        this.events();
    }

    events() {
        let _this = this;

        this.submitButton.click(e => {
            e.preventDefault();
            let email = _this.input.val();

            if (!_this.isValidEmail(email)) {
                _this.input.addClass('form__control-input--error');
            } else {
                _this.input.removeClass('form__control-input--error');

                var _this1 = _this
                submitHubspotForm(email).then(function () {
                    _this1.row.html(_this1.showMessage());
                })
            }
        })


        this.input.on('keyup', e => {
            e.preventDefault();
            let email = _this.input.val();

            if (_this.isValidEmail(email)) {
                _this.input.removeClass('form__control-input--error');
                _this.submitButton.addClass('form__control-submit--valid');
            } else {
                _this.submitButton.removeClass('form__control-submit--valid');
            }
        })

    }

    //show message
    showMessage() {
        let _this = this;
        _this.form.html('<legend class="subtitle--1 stock-form__title">Thanks!<br>You’ll receive an email when a 16oz <strong>Apple Cider Vinegar</strong> is back in stock.</legend> <a class="mt-xs-8 btn btn--primary">BROWSE MORE PRODUCTS</a>')
    }

    //checking email if it valid email or not
    isValidEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

}

export default Notify;
